var exports = {
  "kL": "xdbfd91f1--f79024--container",
  "S3": "xdbfd91f1--f79024--content_container",
  "wx": "xdbfd91f1--f79024--header",
  "e3": "xdbfd91f1--f79024--image_container",
  "YG": "xdbfd91f1--f79024--header-icon",
  "BJ": "xdbfd91f1--f79024--header-title",
  "h_": "xdbfd91f1--f79024--description",
};

module.exports = exports;
